import React, { Component } from "react";
import _ from "i18n";
import styles from "../SlideCompositionPage.local.scss";
import { connect } from "react-redux";
import Autocomplete from "../Autocomplete";
import SelectNumberYears from "../SelectNumberYears";
import { addComponentIndicator } from "Actions";
import SelectCategory from "../SelectCategory";
import AddIndicatorsExplanation from "./AddIndicatorsExplanation";
import InputsLanguages from "../../Common/InputsLanguages/InputsLanguages";

class NumberOfYearsComponentConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Indicator: [],
      btnAdd: false,
      btnLess: false,
      updatedIndicator: this.props.componentConfig.indicators
    };
    this.renderIndicatorSelect();
  }

  removeSelect() {
    const { dispatch } = this.props;
    let index = this.state.Indicator.length;
    let indicator = [...this.state.Indicator];
    const {
      componentConfig: { indicators }
    } = this.props;
    let newIndicator = indicators;
    newIndicator.length = index - 1;
    // newIndicator[index - 1].splice(index - 1);
    dispatch(addComponentIndicator(newIndicator));
    if (index > 1) {
      this.setState({
        btnAdd: false
      });
      indicator.splice(index - 1);
      this.setState({
        Indicator: indicator
      });
    } else {
      this.setState({
        btnLess: true
      });
    }
  }

  removeUpdatedSelect() {
    const { dispatch } = this.props;
    let index = this.state.updatedIndicator.length;
    let indicator = [...this.state.updatedIndicator];
    const {
      componentConfig: { indicators }
    } = this.props;
    let newIndicator = indicators;
    newIndicator.length = index - 1;
    // newIndicator[index - 1].splice(index - 1);
    dispatch(addComponentIndicator(newIndicator));
    if (index > 1) {
      this.setState({
        btnAdd: false
      });
      indicator.splice(index - 1);
      this.setState({
        updatedIndicator: indicator
      });
    } else {
      this.setState({
        btnLess: true
      });
    }
  }

  addIndicatorSelect() {
    let indicators = [...this.state.Indicator];
    let indexSelect = this.state.Indicator.length;
    if (indexSelect < 10) {
      this.setState({
        btnLess: false
      });
      indicators.push(
        <div>
          <div
            className={styles.select_label}
            style={{ marginLeft: "15px", marginTop: "20px" }}
          >
            {_("indicator")} {indexSelect + 1}
          </div>
          <div>
            <Autocomplete
              indicateurs={this.props.suggestions}
              addComponentIndicator={this.props.HandleAddComponentIndicator}
              indicatorNum={indexSelect}
              indicatorUpdate={this.props.componentConfig.indicators}
              addSlideIndicators={this.props.HandleAddSlideIndicator}
              isSampleConfig={false}
            />
          </div>
        </div>
      );
      this.setState({
        Indicator: indicators
      });
    } else {
      this.setState({
        btnAdd: true
      });
    }
  }

  addUpdateIndicatorSelect() {
    let UpdateIndex = this.state.updatedIndicator.length;
    let indicator = [...this.state.updatedIndicator];
    if (UpdateIndex < 10) {
      this.setState({
        btnLess: false
      });
      indicator.push(
        <div key={UpdateIndex + 1}>
          <div
            className={styles.select_label}
            style={{ marginLeft: "15px", marginTop: "20px" }}
          >
            {_("indicator")} {UpdateIndex + 1}
          </div>
          <div>
            <Autocomplete
              indicateurs={this.props.suggestions}
              addComponentIndicator={this.props.HandleAddComponentIndicator}
              indicatorNum={UpdateIndex}
              indicatorUpdate={this.props.componentConfig.indicators}
              addSlideIndicators={this.props.HandleAddSlideIndicator}
              isSampleConfig={false}
            />
          </div>
        </div>
      );
      this.setState({
        updatedIndicator: indicator
      });
    } else {
      this.setState({
        btnAdd: true
      });
    }
  }

  renderIndicatorSelect() {
    for (let i = 0; i < 3; i++) {
      this.state.Indicator.push(
        <div key={i}>
          <div
            className={styles.select_label}
            style={{ marginLeft: "15px", marginTop: "20px" }}
          >
            {_("indicator")} {i + 1} {i === 0 && "*"}
          </div>
          <div>
            <Autocomplete
              indicateurs={this.props.suggestions}
              addComponentIndicator={this.props.HandleAddComponentIndicator}
              indicatorNum={i}
              indicatorUpdate={this.props.componentConfig.indicators}
              addSlideIndicators={this.props.HandleAddSlideIndicator}
              isSampleConfig={false}
            />
          </div>
        </div>
      );
    }
  }
  render() {
    const {
      componentConfig: { labels, indicators },
      selectedComponent,
      saving,
      fetching,
      componentConfig,
      componentAction
    } = this.props;
    return (
      <div>
        <div className={styles.config_text}>{_("componentConfig")}</div>
        <div style={{ marginTop: "15px" }}>
          <img
            src={`/img/slide-composition/component-image/${selectedComponent}`}
            alt={""}
            className={styles.component_config_img}
          />
        </div>
        <InputsLanguages
          handleChangeComponentLabels={this.props.HandleChangeComponentLabels}
          componentConfig={componentConfig}
        />
        <div>
          <div
            className={styles.labels_form_block}
            style={{ marginTop: "10px" }}
          >
            <div className={styles.nbr_years}>
              <div
                className={styles.select_label}
                style={{ marginLeft: "30px", marginTop: "20px" }}
              >
                {_("nbrOfYears")} {"*"}
              </div>
              <div>
                <SelectNumberYears
                  selectYear={this.props.HandleSelectYearsNumber}
                  configUpdate={this.props.componentConfig.config}
                  isSampleConfig={false}
                />
              </div>
            </div>
            <div
              className={
                componentAction === "ADD" ? styles.component_config : ""
              }
            >
              {componentAction === "ADD" &&
                this.state.Indicator.map((item, i) => {
                  return item;
                })}
            </div>
            <div
              className={
                componentAction === "UPDATE" ? styles.component_config : ""
              }
            >
              {componentAction === "UPDATE" &&
                this.state.updatedIndicator.map((item, j) => {
                  return (
                    <div>
                      <div
                        className={styles.select_label}
                        style={{ marginLeft: "15px", marginTop: "20px" }}
                      >
                        Indicateur {j + 1}
                      </div>
                      <div>
                        <Autocomplete
                          indicateurs={this.props.suggestions}
                          addComponentIndicator={
                            this.props.HandleAddComponentIndicator
                          }
                          indicatorNum={j}
                          indicatorUpdate={
                            this.props.componentConfig.indicators
                          }
                          addSlideIndicators={
                            this.props.HandleAddSlideIndicator
                          }
                          isSampleConfig={false}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className={styles.category}>
              <div className={`row`} style={{ marginTop: "10px" }}>
                <div>
                  <button
                    className={styles.btn}
                    onClick={e =>
                      componentAction === "ADD"
                        ? this.addIndicatorSelect()
                        : this.addUpdateIndicatorSelect()
                    }
                  >
                    {"+"}
                  </button>
                </div>
                <div>
                  <button
                    className={styles.btn}
                    onClick={e =>
                      componentAction === "ADD"
                        ? this.removeSelect()
                        : this.removeUpdatedSelect()
                    }
                  >
                    {"-"}
                  </button>
                </div>
              </div>
            </div>
            <div className={styles.category}>
              <div className={styles.select_category}>
                {_("attacherAnnexeCategorie")}
              </div>
              <div style={{ marginTop: "10px" }}>
                <SelectCategory
                  annexeCategories={this.props.annexeCategories}
                  HandleSelectAnnexeCategory={
                    this.props.HandleSelectAnnexeCategory
                  }
                  categoryUpdate={
                    this.props.componentConfig.config.annexeAttachmentCategory
                  }
                  isBarometer={false}
                  isTable={true}
                  isSampleConfig={false}
                />
              </div>
            </div>
            <AddIndicatorsExplanation
              explanation={this.props.explanation}
              handlerIndicatorsExplanation={
                this.props.handlerIndicatorsExplanation
              }
              OpenIndicatorsExplanationModal={
                this.props.OpenIndicatorsExplanationModal
              }
              isBarometerConfig={false}
              isTableConfig={true}
            />
          </div>
        </div>
        <div className={styles.actions_block}>
          <button
            className={styles.btn_back}
            onClick={() => this.props.HandleChangeSideBar("ComponentList", "")}
            style={{ marginRight: "5px" }}
          >
            <img src="/img/icons/back.svg" alt={""} />
          </button>

          {componentAction === "ADD" ? (
            <button
              className={styles.btn_validate}
              onClick={() => this.props.HandleSaveComponentConfig()}
              disabled={
                (labels["fr"].length === 0 &&
                  labels["en"].length === 0 &&
                  labels["nl"].length === 0) ||
                indicators.length === 0
              }
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={saving || fetching ? styles.loading : ""}
              />
              <span>{_("validate")}</span>
            </button>
          ) : (
            <button
              className={styles.btn_validate}
              onClick={() =>
                this.props.handleUpdateComponent(this.props.selectedCase)
              }
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={saving || fetching ? styles.loading : ""}
              />
              <span>{_("edit")}</span>
            </button>
          )}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  suggestions: state.indicators.suggestions.items,
  selectedComponent: state.slideComposition.composition.selectedComponent,
  selectedCase: state.slideComposition.composition.layout.selectedCase,
  slideId: state.slideComposition.slideId,
  saving: state.slideComposition.saving,
  fetching: state.slideComposition.fetchSlide.fetching,
  componentConfig: state.slideComposition.componentConfig,
  componentAction: state.slideComposition.ComponentAction,
  annexeCategories: state.annexeCategorySuggestions.enabled
});

export default connect(mapStateToProps)(NumberOfYearsComponentConfiguration);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/ComponentConfiguration/NumberOfYearsComponentConfiguration.js